import usePersistentPayerCode from "../../hooks/usePersistentPayerCode";
import DeveloperGuideHero from "./DeveloperGuideHero";
import OncCertificationInfo from "./OncCertificationInfo";
import DeveloperGuideMetadata from "./DeveloperGuideMetadata";
import CertificationCoverage from "./CertificationCoverage";

const ApiDocumentation = () => {
  usePersistentPayerCode();

  return (
    <div className="page-layout api-layout overflow-x-hidden!">
      <div className="flex flex-col gap-6">
        <DeveloperGuideHero />
        <DeveloperGuideMetadata />
        <OncCertificationInfo />
        <CertificationCoverage />
      </div>
    </div>
  );
};

export default ApiDocumentation;
